import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttachedFile } from '../../support/support.model';
import { PortNumberUploadForm } from '../port-phonenumber.model';
import { DraftSaveStatus } from '../phonenumber-save-draft-card/phonenumber-save-draft-card.component';

@Component({
    selector: 'app-upload-port-form',
    templateUrl: './upload-port-form.component.html',
    styles: [],
    standalone: false
})
export class UploadPortFormComponent {
  @Output() selected: EventEmitter<PortNumberUploadForm> = new EventEmitter<PortNumberUploadForm>();
  @Output() saveDraft: EventEmitter<void> = new EventEmitter<void>();
  @Output() closeDraft: EventEmitter<void> = new EventEmitter<void>();

  @Input() draftEnabled: boolean = true;
  @Input() draftStatus: DraftSaveStatus = 'idle';

  public showDraftBox = true;

  public files: AttachedFile[] = [];

  public changed(files: AttachedFile[]) {
    this.files = files;
    this.showDraftBox = files.length === 0;
  }

  public onNext() {
    if (this.files.length === 0) {
      return;
    }

    const file: File = this.files[0].file; // We can only upload one file

    const reader = new FileReader();
    reader.onloadend = () => {
      const fileResult = reader.result.toString().replace(/^[^,]*,/, '');
      const uploadData: PortNumberUploadForm = {
        file_name: file.name,
        file_body_b64: fileResult,
        file: file,
      };
      this.selected.emit(uploadData);
    };
    reader.readAsDataURL(file);
  }
}
